var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zone"},[_c('v-lazy-img',{attrs:{"data-url":_vm.image.url}}),_vm._v(" "),_vm._l((_vm.zone),function(item){return [(item.url_object && item.url_object.url)?_c('a',{key:item.id,class:{ 'is-preview': _vm.isPreview },style:({
        width: _vm.computed_size(item.percentage_width),
        height: _vm.computed_size(item.percentage_height),
        top: _vm.computed_size(item.percentage_y),
        left: _vm.computed_size(item.percentage_x),
      }),attrs:{"href":item.url_object.url}}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }